export const container = 'p-6 mx-7';
export const homeText = 'text-xl';
export const gridContainer = 'grid grid-cols-1 md:grid-cols-2 my-4';
export const sectionTitle = 'text-xl font-bold';
export const sectionSubtitle = 'text-sm';
export const imageContainer = 'my-3';
export const cardTitle = 'text-sm font-bold';
export const cardSubtitle = 'text-xs';
export const cardGrid = 'grid grid-cols-1 md:grid-cols-2 gap-4';
export const cardTextBold = 'text-sm font-semibold';
export const selectGrid = 'my-3 grid grid-cols-1 md:grid-cols-2 gap-4';
export const referralText = 'font-normal text-xs';
export const buttonContainer = 'w-full flex justify-center items-center';
export const proceedButton = 'w-3/4 bg-custom-button-green flex items-center gap-6';
export const buttonIcon = 'mt-1';
